module.exports = __webpack_public_path__ + "static/media/icon-photo.1d7c268f.svg";